'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Replaces the default swagger-ui `OperationSummary` component. This component
 * is more extendable.  Using `OperationActions`, UI elements can be added to
 * the operation summary.  The OperationActions now includes the authorization
 * button (lock icon).
 */
var OperationSummary = function (_PureComponent) {
	_inherits(OperationSummary, _PureComponent);

	function OperationSummary() {
		_classCallCheck(this, OperationSummary);

		return _possibleConstructorReturn(this, (OperationSummary.__proto__ || Object.getPrototypeOf(OperationSummary)).apply(this, arguments));
	}

	_createClass(OperationSummary, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    toggleShown = _props.toggleShown,
			    getComponent = _props.getComponent,
			    authActions = _props.authActions,
			    authSelectors = _props.authSelectors,
			    operationProps = _props.operationProps,
			    specPath = _props.specPath;

			var _operationProps$toJS = operationProps.toJS(),
			    summary = _operationProps$toJS.summary,
			    method = _operationProps$toJS.method,
			    op = _operationProps$toJS.op,
			    showSummary = _operationProps$toJS.showSummary,
			    operationId = _operationProps$toJS.operationId,
			    originalOperationId = _operationProps$toJS.originalOperationId,
			    displayOperationId = _operationProps$toJS.displayOperationId;

			var resolvedSummary = op.resolvedSummary;


			var resolvedOperationId = originalOperationId || operationId;
			var OperationSummaryMethod = getComponent('OperationSummaryMethod');
			var OperationSummaryPath = getComponent('OperationSummaryPath');
			var OperationActions = getComponent('OperationActions');
			var JumpToPath = getComponent('JumpToPath', true);

			return _react2.default.createElement(
				'div',
				{ className: 'opblock-summary opblock-summary-' + method, onClick: toggleShown },
				_react2.default.createElement(
					'div',
					{ className: 'operation-summary' },
					_react2.default.createElement(OperationSummaryMethod, { method: method }),
					_react2.default.createElement(OperationSummaryPath, { getComponent: getComponent, operationProps: operationProps, specPath: specPath }),
					showSummary && _react2.default.createElement(
						'div',
						{ className: 'opblock-summary-description' },
						'' + (resolvedSummary || summary)
					),
					displayOperationId && resolvedOperationId && _react2.default.createElement(
						'span',
						{ className: 'opblock-summary-operation-id' },
						resolvedOperationId
					)
				),
				_react2.default.createElement(OperationActions, {
					authActions: authActions,
					authSelectors: authSelectors,
					getComponent: getComponent,
					operationProps: operationProps,
					specPath: specPath,
					key: 'operation-action'
				}),
				_react2.default.createElement(JumpToPath, { path: specPath })
			);
		}
	}]);

	return OperationSummary;
}(_react.PureComponent);

var _default = OperationSummary;
exports.default = _default;


OperationSummary.propTypes = {
	/**
  * The auth actions component.
  */
	authActions: _propTypes2.default.object.isRequired,
	/**
  * The swagger-ui auth selectors.
  */
	authSelectors: _propTypes2.default.object.isRequired,
	/**
  * The swagger-ui getComponent function.
  */
	getComponent: _propTypes2.default.func.isRequired,
	/**
  * The swagger-ui operation propertties
  */
	operationProps: _propTypes2.default.object.isRequired,
	/**
  * The swagger-ui spec path
  */
	specPath: _propTypes2.default.object.isRequired,
	/**
  * A callback function to show summary
  */
	toggleShown: _propTypes2.default.func.isRequired
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(OperationSummary, 'OperationSummary', 'src/components/OpenAPI/OperationSummary.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/OpenAPI/OperationSummary.jsx');
}();

;